var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes,
    attrs: {
      "aria-label": _vm.label,
      "role": "img"
    }
  }, [(_vm.source) ? _c('polaris-image', {
    staticClass: "Polaris-Avatar__Image",
    attrs: {
      "role": "presentation",
      "source": _vm.source,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.source && !_vm.customer) ? _c('span', {
    staticClass: "Polaris-Avatar__Initials",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.initials) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.source && _vm.customer) ? _c('span', {
    staticClass: "Polaris-Avatar__Image",
    domProps: {
      "innerHTML": _vm._s(_vm.customerSvg)
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6113bb10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6113bb10","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisAvatar.vue
// module id = 163
// module chunks = 0